import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { ActionButton, FormDialog, SelectInput } from "../common";
import { TrailerPMForm } from "./TrailerPMForm";
import { TruckTractorForm } from "./TruckTractorForm";
import { TERMINAL } from "./fields";

const PM_FORM_COMPONENTS = { trailer_pm: TrailerPMForm, truck_tractor_pm: TruckTractorForm };

export const TrailerPMTemplateActions = ({ template }) => {
  const navigate = useNavigate();
  const PmForm = PM_FORM_COMPONENTS[template.form_kind] || TrailerPMForm;
  const [preview, setPreview] = useState(false), [attach, setAttach] = useState(false);
  const [orders, setOrders] = useState([]), [chosen, setChosen] = useState("");
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const load = async () => {
    setAttach(true); setBusy(true); setError(""); setChosen(""); setOrders([]);
    try { setOrders((await api.get("/fleet/work-orders")).data.filter((order) => !TERMINAL.includes(order.status) && !(order.checklists || []).some((copy) => copy.template_id === template.id))); }
    catch (failure) { setError(errMsg(failure)); } finally { setBusy(false); }
  };
  const useTemplate = async () => {
    const order = orders.find((item) => item.id === chosen); if (!order) return;
    setBusy(true); setError("");
    try {
      await api.post(`/fleet/work-orders/${order.id}/checklists`, { template_id: template.id, version: order.version || 0 });
      toast.success("Trailer PM inspection attached"); navigate(`/fleet/work-orders?work_order=${encodeURIComponent(order.id)}`);
    } catch (failure) { setError(errMsg(failure)); } finally { setBusy(false); }
  };
  return <>
    <div className="flex flex-wrap gap-2">
      <ActionButton testId="trailer-pm-preview-button" variant="secondary" onClick={() => setPreview(true)}>Preview Form</ActionButton>
      <ActionButton testId="trailer-pm-use-button" onClick={load}>Use on Work Order</ActionButton>
    </div>
    <FormDialog open={preview} onOpenChange={setPreview} title={template.name} testId="trailer-pm-preview-dialog" className="w-[calc(100%_-_1rem)] max-w-6xl">
      <PmForm copy={{ ...template, id: "preview", form_data: {} }} disabled preview />
    </FormDialog>
    <FormDialog open={attach} onOpenChange={(value) => { if (!busy) setAttach(value); }} title={`Attach ${template.name}`} testId="trailer-pm-attach-dialog" className="w-[calc(100%_-_2rem)] max-w-xl">
      <p className="text-sm text-slate-600" data-testid="trailer-pm-attach-help">Each Work Order keeps a separate inspection. Only its assigned employee can fill and certify it.</p>
      {error && <p role="alert" data-testid="trailer-pm-attach-error" className="text-sm text-red-700">{error}</p>}
      {busy && <p role="status" data-testid="trailer-pm-attach-loading">Please wait…</p>}
      {!busy && !error && !orders.length && <p data-testid="trailer-pm-no-orders" className="text-sm">No editable Work Orders need this checklist. <Link to="/fleet/work-orders" data-testid="trailer-pm-create-order-link" className="underline text-[#84252F]">Create a Work Order</Link> first.</p>}
      <SelectInput testId="trailer-pm-work-order-select" aria-label="Work Order for inspection" value={chosen} onChange={(event) => setChosen(event.target.value)} placeholder="Select Work Order" disabled={busy} options={orders.map((order) => ({ value: order.id, label: `${order.wo_number} · ${order.asset_name} · ${order.issue}` }))} />
      <div className="flex flex-wrap gap-2"><ActionButton testId="trailer-pm-attach-confirm" disabled={busy || !chosen} onClick={useTemplate}>Attach & Open Work Order</ActionButton><ActionButton testId="trailer-pm-attach-refresh" variant="secondary" disabled={busy} onClick={load}>Refresh Orders</ActionButton></div>
    </FormDialog>
  </>;
};
